export default function getPropByString(obj, propString) {
  if (!propString) {
    return obj
  }

  let prop
  const props = propString.split('.')

  let result = { ...obj }

  for (let i = 0; i < props.length; i++) {
    prop = props[i]

    const candidate = result[prop]

    if (candidate !== undefined) {
      result = candidate
    } else {
      return undefined
    }
  }
  return result
}
